import * as yup from "yup";

const ExportValidationSchema = yup.object().shape({
  jobName: yup
    .string()
    .max(100)
    .required("Please complete the job name field."),
});

export default ExportValidationSchema;
